// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.records-container {
  padding: 1rem;
}

.record-section {
  margin-bottom: 2rem;
}

.record-section h3 {
  margin-bottom: 0.5rem;
  color: #333;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 0.5rem;
}

.data-table th,
.data-table td {
  padding: 8px;
  border: 1px solid #ccc;
}

.data-table th {
  background-color: #f4f4f4;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/Records.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".records-container {\n  padding: 1rem;\n}\n\n.record-section {\n  margin-bottom: 2rem;\n}\n\n.record-section h3 {\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 0.5rem;\n}\n\n.data-table th,\n.data-table td {\n  padding: 8px;\n  border: 1px solid #ccc;\n}\n\n.data-table th {\n  background-color: #f4f4f4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
